import { DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import { ProviderModel } from '@models/types'

interface ProviderProps {
  callbacks?: {
    onClick: () => void,
  },
  entity: ProviderModel,
  selected: boolean,
}

const Provider = (props: ProviderProps) => {
  const {
    callbacks,
    entity: { id, title },
    selected,
  } = props

  const { onClick } = callbacks || {}

  return (
    <DashboardModuleListItem
      isChecked={selected}
      onClick={onClick}
      showCheckbox
      title={title}
    >
      <Text color="bodyFontLightColor">ID #{id}</Text>
    </DashboardModuleListItem>
  )
}

export default Provider
